$(function() {
    var related_course_container = $('#related-courses-container');

    var course_id = related_course_container.data('course_id');
    var user_id =  related_course_container.data('user_id');
    var cart_id =  related_course_container.data('cart_id');
    var tax_included =  related_course_container.data('tax_included');

    if (! course_id) {
        return;
    }

    $.post("/courses/" + course_id + "/related", {
        user_id: user_id,
        cart_id: cart_id,
        tax_included: tax_included
    }).done((response) => {
        $("#related-courses-container").html(response);
    }).fail((response) => {
        $("#related-courses-container").html("<p>Non siamo riusciti a caricare i corsi per te.</p>");
    })
})

$(function() {
    var bundle_container = $('#bundle-container');

    var product_id = bundle_container.data('product_id');
    var user_id =  bundle_container.data('user_id');
    var cart_id =  bundle_container.data('cart_id');

    if (! product_id || ! cart_id) {
        bundle_container.html("");
        return;
    }

    $.post("/courses/bundle", {
        product_id: product_id,
        user_id: user_id,
        cart_id: cart_id
    }).done((response) => {
        if (response.data) {
            bundle_container.html(response.data);

            return;
        }

        bundle_container.html("");
    }).fail((response) => {
        $("#bundle-container").html("<p>Non siamo riusciti a caricare i bundle per te.</p>");
    })
})
